import { useContext, useEffect, useRef, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-hot-toast";
import usePatientFormStore from "../../../../hooks/usePatientFormStore";
import alpha3To2 from "./alpha3To2";
import { UserContext } from "../../../../Context/UserContextAPI";

const PassportScanner = ({ setInputValue, setBase64ProfilePhoto }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDeviceConnected, setIsDeviceConnected] = useState(false);
  const wsRef = useRef(null);
  const { countryUsers } = useContext(UserContext);

  const getAlpha2 = (alpha3) => alpha3To2[alpha3?.toUpperCase()] || null;

  const getCountryId = (alpha3) => {
    const alpha2 = getAlpha2(alpha3);
    const country = countryUsers.find(
      (country) => country?.shortname === alpha2
    );
    return country?.id || null;
  };

  const { setFormData } = usePatientFormStore();

  const processPassportData = (data) => {
    const processedData = data;
    // console.log("processedData", processedData);
    setFormData({
      f_name:
        processedData["English first name"] +
        " " +
        processedData["English surname"],
      passport_no: processedData["The passport number from MRZ"] || "",
      date_of_birth: processedData["Date of birth"] || "",
      gender_id:
        processedData["Sex"] === "M"
          ? "1"
          : processedData["Sex"] === "F"
          ? "2"
          : "", // map gender to internal ID
      // nationality_id: "18", // Assuming Bangladesh is fixed to ID 18
      pe_date: processedData["Date of expiry"] || "",
      // country_id: getCountryId(processedData["Nationality code"]) || "",
    });
  };

  const passportHandler = () => {
    const host = "ws://127.0.0.1:90/echo";
    wsRef.current = new WebSocket(host);

    wsRef.current.onopen = () => {
      console.log("WebSocket connected");

      const onlineStatusRequest = {
        Type: "Request",
        Command: "Get",
        Operand: "OnLineStatus",
      };

      wsRef.current.send(JSON.stringify(onlineStatusRequest));
    };

    wsRef.current.onmessage = (event) => {
      try {
        const response = JSON.parse(event.data);
        console.log("response", response);

        if (
          response.Type === "Reply" &&
          response.Command === "Get" &&
          response.Operand === "OnLineStatus"
        ) {
          if (response.Succeeded === "Y" && response.Result === "设备已连接") {
            toast.success("Passport reader connected.");

            const enableAllFields = [
              { Type: "Request", Command: "Set", Operand: "VIZ", Param: "Y" },
              { Type: "Request", Command: "Set", Operand: "RFID", Param: "Y" },
              {
                Type: "Request",
                Command: "Set",
                Operand: "IfDetectUVDull",
                Param: "True",
              },
              {
                Type: "Request",
                Command: "Set",
                Operand: "MRZOnWhiteImage",
                Param: "True",
              },
            ];

            // Send each setup instruction
            enableAllFields.forEach((req) => {
              wsRef.current.send(JSON.stringify(req));
            });

            if (
              response.Type === "Reply" &&
              response.Command === "Set" &&
              response.Operand === "VIZ" &&
              response.Succeeded === "Y"
            ) {
              // console.log("VIZ enabled");

              const scanRequest = {
                Type: "Notify",
                Command: "Trigger",
                Operand: "ManualRecog",
                Param: 30,
              };

              wsRef.current.send(JSON.stringify(scanRequest));
            }

            // const scanRequest = {
            //   Type: "Notify",
            //   Command: "Trigger",
            //   Operand: "ManualRecog",
            //   Param: 30, // scanning timeout
            // };
            // wsRef.current.send(JSON.stringify(scanRequest));
          } else {
            toast.error("Passport reader not connected.");
            setModalOpen(false);
            wsRef.current.close();
          }
        }

        if (
          response.Type === "Notify" &&
          response.Operand === "CardContentText"
        ) {
          toast.success("Passport data received.");
          console.log("Passport Data:", response.Param);
          processPassportData(response.Param);
          setModalOpen(false);
          wsRef.current.close();
        }

        if (
          response.Type === "Notify" &&
          response.Operand === "RealtimeMessage"
        ) {
          toast.warning(response.Param || "Device status changed.");
        }
      } catch (err) {
        console.error("Message parsing error:", err);
        toast.error("Failed to process device response.");
        setModalOpen(false);
        wsRef.current?.close();
      }
    };

    wsRef.current.onerror = (err) => {
      console.error("WebSocket error:", err);
      toast.error("Could not connect to WebSocket service.");
      setModalOpen(false);
    };

    wsRef.current.onclose = () => {
      console.log("WebSocket closed.");
    };
  };

  const passportHandler2 = () => {
    const host = "ws://127.0.0.1:90/echo";
    const ws = new WebSocket(host);

    ws.onopen = () => {
      console.log("🔌 WebSocket connected");

      const onlineStatusRequest = {
        Type: "Request",
        Command: "Get",
        Operand: "OnLineStatus",
      };
      ws.send(JSON.stringify(onlineStatusRequest));
    };

    ws.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        console.log("📩 Received:", msg);

        // ✅ Confirm device connection
        if (
          msg.Type === "Reply" &&
          msg.Command === "Get" &&
          msg.Operand === "OnLineStatus"
        ) {
          if (msg.Succeeded === "Y" && msg.Result === "设备已连接") {
            toast.success("Device connected");
            setIsDeviceConnected(true);

            // ✅ Batch send settings
            const configBatch = {
              Type: "Request",
              Commands: [
                { Command: "Set", Operand: "VIZ", Param: "Y" },
                { Command: "Set", Operand: "RFID", Param: "Y" },
                { Command: "Set", Operand: "IfDetectUVDull", Param: "True" },
                { Command: "Set", Operand: "MRZOnWhiteImage", Param: "True" },
                { Command: "Set", Operand: "IfEnableCallback", Param: "False" },
              ],
            };
            ws.send(JSON.stringify(configBatch));

            // ✅ Trigger scan after delay
            setTimeout(() => {
              const triggerScan = {
                Type: "Notify",
                Command: "Trigger",
                Operand: "ManualRecog",
                Param: 30,
              };
              ws.send(JSON.stringify(triggerScan));
            }, 500);
          } else {
            setIsDeviceConnected(false);
            toast.error("Device not connected");
            ws.close();
            setModalOpen(false);
          }
        }

        // 📝 Text info
        if (msg.Type === "Notify" && msg.Operand === "CardContentText") {
          toast.success("📄 Passport info received");
          console.log("Text Data:", msg.Param);
          // You can forward msg.Param to your parser here
          processPassportData(msg.Param);
        }

        // 🖼️ Image info
        if (msg.Type === "Notify" && msg.Operand === "Images") {
          toast.success("🖼️ Passport image received");
          Object.entries(msg.Param).forEach(([key, base64]) => {
            // console.log(`→ ${key}: ${base64}`);
            if (key === "OcrHead") {
              // console.log("OcrHead", base64);
              setBase64ProfilePhoto(base64);
              setModalOpen(false);
              ws.close();
              setIsDeviceConnected(false);
            }
          });
        }

        // 📡 Real-time device message
        if (msg.Type === "Notify" && msg.Operand === "RealtimeMessage") {
          toast.warning(msg.Param || "Device status changed");
        }
      } catch (err) {
        console.error("❌ Parsing failed:", err);
        toast.error("Response error");
        ws.close();
        setIsDeviceConnected(false);
      }
    };

    ws.onerror = (err) => {
      console.error("💥 WebSocket error:", err);
      toast.error(
        "Connection failed. Please Check if the device is connected or the driver is installed."
      );
      ws.close();
      setIsDeviceConnected(false);
      setModalOpen(false);
    };

    ws.onclose = () => {
      console.log("🔌 WebSocket closed");
    };
  };

  useEffect(() => {
    if (isModalOpen) {
      passportHandler2();
    } else {
      // 🧼 Clean up WebSocket when modal closes
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.close();
        setIsDeviceConnected(false);
        console.log("WebSocket closed on modal dismiss");
      }
    }
  }, [isModalOpen]);

  return (
    <div>
      <div
        className="col-form-label"
        style={{
          padding: "10px",
        }}
      >
        <img
          src={"passport.jpg"}
          alt="Passport"
          style={{
            width: "8.5rem",
            height: "8.5rem",
            border: "5px solid red",
            borderRadius: "50%",
            cursor: "pointer",
            padding: "4px",
          }}
          onClick={() => setModalOpen(true)}
        />
      </div>

      <Modal
        show={isModalOpen}
        onHide={() => {
          setModalOpen(false);
          setIsDeviceConnected(false);
          wsRef.current?.close();
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Scan the passport</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {isDeviceConnected && "Device is connected. "}
            Please scan the passport to continue.
          </p>
          <div className="text-center mt-5">
            <Spinner
              animation="border"
              variant="success"
              style={{ width: "5rem", height: "5rem" }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PassportScanner;
